import React from "react";
import "./Gallery.css";

const galleryImages = [
  { id: 1, src: require("../assets/gallery/IMG_4003.jpg") },
  { id: 2, src: require("../assets/gallery/IMG_3997.jpg") },
  { id: 3, src: require("../assets/gallery/IMG_4010.jpg") },
  { id: 4, src: require("../assets/gallery/IMG_4005.jpg") },
  { id: 5, src: require("../assets/gallery/IMG_4008.jpg") },
  { id: 6, src: require("../assets/gallery/IMG_4015.jpg") },
  { id: 7, src: require("../assets/gallery/IMG_4016.jpg") },
  { id: 8, src: require("../assets/gallery/IMG_4018.jpg") },
  { id: 9, src: require("../assets/gallery/IMG_4019.jpg") },
];

const Gallery = () => {
  return (
    <section className="gallery" id="gallery">
      <h2 className="gallery-title">Our Gallery</h2>
      <p className="gallery-subtitle">
        Explore our latest paint and hardware projects.
      </p>

      <div className="gallery-grid">
        {galleryImages.map((item) => (
          <div key={item.id} className="gallery-item">
            <img src={item.src} alt={item.title} />
            <div className="overlay">
              <span>{item.title}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
